(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carousel-landing-page"] && !Shopify.designMode) return;
  try {
    
class Carousel {
  constructor(section) {
    this.section = section;
    this.sectionId = section.getAttribute('data-carousel-section');
    this.carousel = section.querySelector(`[data-carousel="${this.sectionId}"]`);
    if (!this.carousel) return;

    this.items = this.carousel.querySelectorAll('.carousel-item');
    this.dots = section.querySelectorAll('.dot');
    this.prevButton = section.querySelector('.prev-button');
    this.nextButton = section.querySelector('.next-button');
    this.currentIndex = 0;

    this.init();
  }

  init() {
    if (this.items.length === 0) return;

    // Event listeners
    this.prevButton?.addEventListener('click', () => this.prevSlide());
    this.nextButton?.addEventListener('click', () => this.nextSlide());
    
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.goToSlide(index));
    });

    // Show initial slide
    this.showSlide(0);
  }

  showSlide(index) {
    // Hide all slides
    this.items.forEach(item => {
      item.style.display = 'none';
      item.classList.remove('active');
    });

    // Remove active class from all dots
    this.dots.forEach(dot => dot.classList.remove('active'));

    // Show current slide and activate corresponding dot
    if (this.items[index]) {
      this.items[index].style.display = 'block';
      this.items[index].classList.add('active');
      this.dots[index].classList.add('active');
    }

    this.currentIndex = index;
  }

  nextSlide() {
    const nextIndex = (this.currentIndex + 1) % this.items.length;
    this.showSlide(nextIndex);
  }

  prevSlide() {
    const prevIndex = (this.currentIndex - 1 + this.items.length) % this.items.length;
    this.showSlide(prevIndex);
  }

  goToSlide(index) {
    this.showSlide(index);
  }
}

// Initialize all carousels when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
  const carouselSections = document.querySelectorAll('[data-carousel-section]');
  carouselSections.forEach(section => new Carousel(section));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cmc-configurator"] && !Shopify.designMode) return;
  try {
     function initializeCMCConfigurator(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    const settings = JSON.parse(root.dataset.builderSettings);
    const escapeHTML = (value) => {
      const span = document.createElement('span');
      span.textContent = value;
      return span.innerHTML;
    };

    const optionInputs = Array.from(root.querySelectorAll('[data-option]'));
    const machineName = root.querySelector('[data-machine-name]');
    const machineCopy = root.querySelector('[data-machine-copy]');
    const nameExplanation = root.querySelector('[data-name-explanation]');
    const optionCards = new Map(Array.from(root.querySelectorAll('[data-option-card]')).map((card) => [card.dataset.optionCard, card]));
    const optionStates = new Map(Array.from(root.querySelectorAll('[data-option-state]')).map((state) => [state.dataset.optionState, state]));
    const priceModal = root.querySelector('[data-price-modal]');
    const openPriceModal = root.querySelector('[data-open-price-modal]');
    const closePriceModal = root.querySelector('[data-close-price-modal]');
    const includedCards = root.querySelectorAll('[data-included-item]');
    const includedToast = root.querySelector('[data-included-toast]');
    const printConfigButton = root.querySelector('[data-print-config]');
    let includedToastTimer;
    let activeModal = null;
    let modalTrigger = null;
    let previousOverflow = '';
    const detailModals = new Map(Array.from(root.querySelectorAll('[data-detail-modal]')).map((modal) => [modal.dataset.detailModal, modal]));


    function updateBuilder() {
      const nameParts = [settings.base_name];
      const copyParts = [settings.base_copy];
      const explanations = [settings.base_explanation];

      optionInputs.forEach((input) => {
        const selected = input.disabled || input.checked;
        const state = optionStates.get(input.dataset.option);
        const card = optionCards.get(input.dataset.option);
        if (state) {
          state.textContent = input.disabled ? settings.included_label : selected ? settings.added_label : settings.not_added_label;
          state.classList.toggle('is-added', selected);
        }
        if (card) card.classList.toggle('is-active', selected);
        if (selected) {
          if (input.dataset.suffix) nameParts.push(input.dataset.suffix);
          if (input.dataset.resultCopy) copyParts.push(input.dataset.resultCopy);
          if (input.dataset.explanation) explanations.push(escapeHTML(input.dataset.explanation));
        }
      });

      machineName.textContent = nameParts.filter(Boolean).join(' ');
      machineCopy.textContent = copyParts.filter(Boolean).join(' ');
      nameExplanation.innerHTML = explanations.filter(Boolean).join(' ');
    }

    optionInputs.forEach((input) => input.addEventListener('change', updateBuilder));

    // The card is no longer a label: its details button must not toggle the option.
    optionCards.forEach((card, id) => {
      const input = optionInputs.find((item) => item.dataset.option === id);
      if (!input || input.disabled) return;
      card.addEventListener('click', (event) => {
        if (event.target.closest('button, a, input')) return;
        input.checked = !input.checked;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    includedCards.forEach((card) => {
      card.addEventListener('click', (event) => {
        if (event.target.closest('button, a')) return;
        event.preventDefault();
        const itemName = card.getAttribute('data-included-item') || settings.toast_fallback;
        if (!includedToast) return;
        includedToast.innerHTML = '<strong>' + escapeHTML(settings.included_label) + '</strong> — ' + escapeHTML(itemName) + escapeHTML(settings.toast_suffix);

        const switchEl = card.querySelector('.nxb-switch') || card;
        const rect = switchEl.getBoundingClientRect();
        includedToast.style.left = rect.left + 'px';
        includedToast.style.top = (rect.top + rect.height / 2) + 'px';

        includedToast.classList.add('is-visible');
        clearTimeout(includedToastTimer);
        includedToastTimer = setTimeout(() => {
          includedToast.classList.remove('is-visible');
        }, 2200);
      });
    });

    function openModal(modal, trigger) {
      if (!modal) return;
      if (activeModal) closeModal(false);
      previousOverflow = document.body.style.overflow;
      modalTrigger = trigger || document.activeElement;
      activeModal = modal;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      const closeButton = modal.querySelector('button');
      if (closeButton) closeButton.focus();
    }

    function closeModal(restoreFocus = true) {
      if (!activeModal) return;
      activeModal.classList.remove('is-open');
      activeModal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = previousOverflow;
      activeModal = null;
      if (restoreFocus && modalTrigger && modalTrigger.isConnected) modalTrigger.focus();
      modalTrigger = null;
    }

    if (openPriceModal && priceModal) {
      openPriceModal.addEventListener('click', () => openModal(priceModal, openPriceModal));
    }

    root.querySelectorAll('[data-open-detail]').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        openModal(detailModals.get(button.dataset.openDetail), button);
      });
    });

    detailModals.forEach((modal) => {
      const closeButton = modal.querySelector('[data-close-detail]');
      if (closeButton) closeButton.addEventListener('click', () => closeModal());
      modal.addEventListener('click', (event) => {
        if (event.target === modal) closeModal();
      });
    });

    if (printConfigButton) {
      printConfigButton.addEventListener('click', () => {
        window.print();
      });
    }

    if (closePriceModal) closePriceModal.addEventListener('click', () => closeModal());
    if (priceModal) {
      priceModal.addEventListener('click', (event) => {
        if (event.target === priceModal) closeModal();
      });
    }
    const onKeydown = (event) => {
      if (!activeModal) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal();
      } else if (event.key === 'Tab') {
        const focusable = Array.from(activeModal.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex="0"]')).filter((element) => element.getClientRects().length);
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (!first) { event.preventDefault(); return; }
        if (event.shiftKey && (document.activeElement === first || !activeModal.contains(document.activeElement))) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && (document.activeElement === last || !activeModal.contains(document.activeElement))) {
          event.preventDefault();
          first.focus();
        }
      }
    };
    document.addEventListener('keydown', onKeydown);
    root.nxbCleanup = () => {
      clearTimeout(includedToastTimer);
      document.removeEventListener('keydown', onKeydown);
      closeModal(false);
    };

    updateBuilder();
  }

  document.querySelectorAll('[data-cmc-configurator]').forEach(initializeCMCConfigurator);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-cmc-configurator]').forEach(initializeCMCConfigurator);
  });
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-cmc-configurator]').forEach((root) => {
      if (root.nxbCleanup) root.nxbCleanup();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faqs"] && !Shopify.designMode) return;
  try {
    


(function($) {
    
  var allPanels = $('.accordion > dd').hide();
    
  $('.accordion > dt > a').click(function() {
      $this = $(this);
      $target =  $this.parent().next();
      
    
      if($target.hasClass('active')){
        $target.removeClass('active').slideUp(); 
        $(this).removeClass('active');
      }else{
        allPanels.removeClass('active').slideUp();
        $target.addClass('active').slideDown();
        $(this).addClass('active');
      }
      
    return false;
  });

})(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

  class StickyHeader extends HTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {

      this.header = document.querySelector('.section-header');

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)')
        .addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty(
        '--header-height',
        `${this.header.offsetHeight}px`
      );
    }

    disconnectedCallback() {

      this.removeEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );

      window.removeEventListener(
        'scroll',
        this.onScrollHandler
      );
    }

    createObserver() {

      let observer = new IntersectionObserver((entries, observer) => {

        this.headerBounds = entries[0].intersectionRect;

        observer.disconnect();

      });

      observer.observe(this.header);
    }

    onScroll() {

      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop;

      if (
        this.predictiveSearch &&
        this.predictiveSearch.isOpen
      ) return;

      if (
        scrollTop > this.currentScrollTop &&
        scrollTop > this.headerBounds.bottom
      ) {

        this.header.classList.add('scrolled-past-header');

        if (this.preventHide) return;

        requestAnimationFrame(this.hide.bind(this));

      } else if (
        scrollTop < this.currentScrollTop &&
        scrollTop > this.headerBounds.bottom
      ) {

        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {

          requestAnimationFrame(this.reveal.bind(this));

        } else {

          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }

      } else if (
        scrollTop <= this.headerBounds.top
      ) {

        this.header.classList.remove('scrolled-past-header');

        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {

      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky'
      );

      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {

      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add(
        'shopify-section-header-sticky',
        'animate'
      );

      this.header.classList.remove(
        'shopify-section-header-hidden'
      );
    }

    reset() {

      if (this.headerIsAlwaysSticky) return;

      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );
    }

    closeMenuDisclosure() {

      this.disclosures =
        this.disclosures ||
        this.header.querySelectorAll('header-menu');

      this.disclosures.forEach(
        disclosure => disclosure.close()
      );
    }

    closeSearchModal() {
      // this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      // this.searchModal.close(false);
    }

  }

  customElements.define(
    'sticky-header',
    StickyHeader
  );


  } catch(e) { console.error(e); }
})();
})();
